import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, patchData, postData } from 'src/utils/axios/serverHelper';
import {
    HRM2120_R01BulkParams,
    HRM2120_R01CalendarDto,
    HRM2120_R01DetailDto,
    HRM2120_R01Dto,
    HRM2120_R01HeaderDto,
} from './Dto_HRM2120_R01';
import { HRM2120_R01Filter } from './Store_HRM2120_R01';

/** HRM2120_R01 화면의 API 기본 경로이다. */
const BASE_URL = `${config.apiUrl}/HRM2120_R01`;

/** 조건에 맞는 사원별 기준일 근무조를 가져온다. */
export const getHRM2120_R01List = async (option: string, params: Partial<HRM2120_R01Filter>, listLength = 0) =>
    getData<ResponseDto<HRM2120_R01HeaderDto[]>>(`${BASE_URL}/header/${option}`, {
        params: { ...params, listLength },
    });

/** 조건에 맞는 사원 수를 가져온다. */
export const getHRM2120_R01AllCount = async (params: Partial<HRM2120_R01Filter>) =>
    getData<ResponseDto<number>>(`${BASE_URL}/header/allCount`, { params: { ...params } });

/** 사원의 저장된 배정 이력을 가져온다. */
export const getHRM2120_R01DetailList = async (empNo: string) =>
    getData<ResponseDto<HRM2120_R01DetailDto[]>>(`${BASE_URL}/detail/${encodeURIComponent(empNo)}`);

/** 사원의 저장된 배정을 기준으로 계산한 5주 달력을 가져온다. */
export const getHRM2120_R01CalendarList = async (empNo: string, baseDt: string) =>
    getData<ResponseDto<HRM2120_R01CalendarDto[]>>(`${BASE_URL}/calendar/${encodeURIComponent(empNo)}`, {
        params: { baseDt },
    });

/** 사원 한 명의 배정 이력 전체를 저장한다. */
export const patchHRM2120_R01 = async (data: HRM2120_R01Dto) =>
    patchData<HRM2120_R01Dto, ResponseDto<HRM2120_R01DetailDto[]>>(BASE_URL, data);

/** 조회된 사원에게 일괄 배정한다. */
export const postHRM2120_R01Bulk = async (data: HRM2120_R01BulkParams) =>
    postData<HRM2120_R01BulkParams, ResponseDto<number>>(`${BASE_URL}/bulk`, data);

/** 사원의 배정 이력 Excel을 받는다. */
export const downloadExcel_HRM2120_R01 = async (empNo: string) =>
    getData<ResponseDto<string>>(`${BASE_URL}/detail/${encodeURIComponent(empNo)}/excel`);
